import React from "react";
import "../styles/components/SectionLoader.scss";

const SectionLoader = () => {
  return (
    <div className="sectionLoader">
      <div className="section-loader__wrapper">
        <div className="section-loader__loading-bar"></div>
        <div className="section-loader__loading-bar"></div>
        <div className="section-loader__loading-bar"></div>
        <span className="section-u-els-hide-visually">Loading page</span>
      </div>
    </div>
  );
};

export default SectionLoader;
